import { ThemeProvider } from '@material-ui/core/styles';
import { Modal } from "antd";
import axios from "axios";
import MaterialTable from 'material-table';
import { Component } from 'react';
import { Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';
// import { downloadCSV } from '../../utils/csvDownload';
import { exportAttendanceCsv } from '../../utils/exportAttendanceCsv';
import { hasPermission } from '../../utils/usePermission';
import { DateTimeFormat } from '../DateFormat/DateTimeFormat';

class AttendanceByEmp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      startDate: '',
      endDate: '',
      completed: false,
      color: '',
      employee: "",
      attendanceList: [],
      employeesData: [],
      date: new Date().toISOString().split("T")[0],
      loading: true,
      hasError: false,
      selectedAttendance: null,
      showModal: false,
      username: "",
      password: "",
      showPassword: false,
      isCsvLoading: false,
      showExcelButton: false
    };
  }
  async componentDidMount() {
    let token = localStorage.getItem('token');
    axios({
      method: "get",
      url: "/checkToken",
      headers: { "Authorization": `Bearer ${token}` }
    })
      .then((res) => {
        this.setState({ isAuthenticated: true, loading: false, username: res.data.authData.user.username });
        // console.log("this is response", this.state.username)
      })
      .catch((err) => {
        console.log(err);
        console.log(`Access: ${this.state.isAuthenticated}`);
      });
    this.fetchAttendanceData();
    this.fetchEmployeeData();
  }

  fetchAttendanceData = async () => {
    const { employee, startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      this.setState({ hasError: true, errMsg: "Please select a Date Range." });
      return;
    }

    this.setState({ loading: true });

    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    let requestData = { startDate, endDate };

    if (employee && employee !== "all") {
      requestData.empid = employee;
    }

    try {
      const response = await axios.post("/attendance/attendanceByFilterEmp", requestData, { headers });
      this.setState({ attendanceList: response.data, loading: false, showExcelButton: true });
    } catch (error) {
      console.error("Error fetching attendance:", error);
      let errorMessage = "Failed to load attendance list.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };

  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  fetchEmployeeData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/users', { headers });
      console.log("response?.data ", response?.data);
      this.setState({ employeesData: response?.data });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);
    } catch (error) {
      console.error("Error fetching employee:", error);
      let errorMessage = "Failed to load employee.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };

  csvDownload = async () => {

    this.setState({ isCsvLoading: true });
    const { attendanceList, startDate, endDate } = this.state;
    console.log("csv data is:", attendanceList);

    try {
      await exportAttendanceCsv(attendanceList, 'employee', startDate, endDate); // month and year can be dynamic
    } catch (error) {
      console.error("CSV export failed", error);
    } finally {
      this.setState({ isCsvLoading: false });
    }
  };

  // csvDownload = () => {
  //   downloadCSV(this.state.attendanceList, "Attendance_info_Employee_wise");
  // }


  updateAttendance = (data) => {
    this.setState({ showModal: true, selectedAttendance: { ...data } });
  };

  handleConfirm = () => {
    this.setState({ showModal: true });
  };

  // handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   if (name === "password") {
  //     this.setState({
  //       [name]: value,
  //     });
  //   } else {
  //     this.setState((prevState) => ({
  //       selectedAttendance: {
  //         ...prevState.selectedAttendance,
  //         [name]: value,
  //       },
  //     }));
  //   }
  // };
  calculateHours = (startTime, endTime) => {
    if (!startTime || !endTime) return "";

    const start = startTime.split(":").map(Number);
    const end = endTime.split(":").map(Number);

    const startSeconds = start[0] * 3600 + start[1] * 60 + (start[2] || 0);
    const endSeconds = end[0] * 3600 + end[1] * 60 + (end[2] || 0);

    let diff = endSeconds - startSeconds;

    if (diff < 0) {
      diff += 24 * 3600;
    }

    const hours = (diff / 3600).toFixed(2);
    return hours;
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;


    if (name === "password") {
      this.setState({ password: value });
      return;
    }


    this.setState((prevState) => {
      const updatedAttendance = {
        ...prevState.selectedAttendance,
        [name]: value,
      };

      if (name === "startTime" || name === "endTime") {
        updatedAttendance.numberOfHours = this.calculateHours(
          updatedAttendance.startTime,
          updatedAttendance.endTime
        );
      }

      return { selectedAttendance: updatedAttendance };
    });
  };


  handleConfirmUpdate = () => {
    Modal.confirm({
      title: "Are you sure you want to update attendance?",
      content: "Please confirm before proceeding.",
      onOk: () => {
        this.setState({ showPasswordField: true });
      },
      onCancel: () => {
        this.setState({ showPasswordField: false });
      },
      okText: "Yes, Update",
      cancelText: "Cancel",
    });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };


  handleUpdateAttendance = async () => {
    const { selectedAttendance, password, showPasswordField } = this.state;

    if (!showPasswordField) {
      // If password field is not yet shown, show confirmation first
      this.handleConfirmUpdate();
      return;
    }

    if (!password) {
      this.setState({ showToast: true, toastMessage: "Please enter a password before updating attendance.", toastVariant: "danger", color: 'red' });
      return;
    }

    const attendancePayload = {
      id: selectedAttendance?.id,
      startTime: selectedAttendance?.startTime,
      endTime: selectedAttendance?.endTime,
      username: this.state.username,
      password: password
    };

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", showModal: false });
        return;
      }

      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`/attendance/updatepass`, attendancePayload, { headers });

      if (response.status === 200) {
        this.setState({
          showToast: true,
          toastMessage: "Attendance updated successfully",
          toastVariant: "success",
          color: 'green',
          showModal: false,
          showPasswordField: false,
          password: ""
        });
        this.fetchAttendanceData(); // Refresh data
      } else {
        this.setState({ showToast: true, toastMessage: "Failed to update attendance", toastVariant: "danger", color: 'red' });
      }
    } catch (error) {
      console.error("Error updating attendance:", error);
      this.setState({ showToast: true, toastMessage: "Invalid Credentials ", toastVariant: "danger", color: 'red' });
    }
  };



  decimalToHHMM = (decimalHours) => {
    const hours = Math.floor(decimalHours); // whole hours
    const minutes = Math.round((decimalHours - hours) * 60); // remaining minutes
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };




  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <div className="col-sm-12">
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white">
                <div className="panel-title">
                  <strong>Attendance List By Employee</strong>
                </div>
              </Card.Header>

              <Card.Body>
                <Form>
                  <Row className="align-items-end mb-3">
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label className="required">Employee</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          name="employee"
                          value={this.state.employee}
                          onChange={this.handleFilterChange}
                        >
                          <option value="">Select Employee</option>
                          <option value="all">All Employees</option>
                          {this.state.employeesData.map((emp) => (
                            <option key={emp.id} value={emp.id}>
                              {emp.fullName}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={this.state.startDate}
                          onChange={this.handleFilterChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={this.state.endDate}
                          onChange={this.handleFilterChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={3} className="d-flex gap-2">
                      {hasPermission('M11B5') && (
                        <Button
                          className="button-filter info"
                          variant="outline-primary"
                          onClick={this.fetchAttendanceData}
                        >
                          <i className="fa fa-search"></i>
                        </Button>
                      )}
                      {hasPermission('M11B6') && (
                        <Button
                          className="button-filter info"
                          variant="outline-primary"
                          onClick={this.csvDownload}
                          disabled={
                            !this.state.showExcelButton ||
                            this.state.isCsvLoading ||
                            !this.state.employee ||
                            (!this.state.startDate && !this.state.endDate && this.state.employee !== "all")
                          }
                        >
                          {this.state.isCsvLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-1"></i> Downloading...
                            </>
                          ) : (
                            <i className="fas fa-file-csv"></i>
                          )}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>

                <ThemeProvider>
                  <MaterialTable
                    columns={[
                      { title: 'EMP ID', field: 'empid' },
                      { title: 'Project Name', field: 'projectName' },
                      { title: 'Name', field: 'employeeName' },
                      {
                        title: 'Date', field: 'date',
                        render: (value) => DateTimeFormat(value.date),
                      },
                      { title: 'In Time', field: 'startTime' },
                      { title: 'Out Time', field: 'endTime' },
                      {
                        title: 'Working Hours',
                        field: 'numberOfHours',
                        render: rowData => {


                          return rowData?.numberOfHours ? (
                            <div className="round_attendance">
                              {this.decimalToHHMM(rowData.numberOfHours)}
                            </div>
                          ) : <div className="round_attendance_zero">0</div>;

                        }
                      },
                      {
                        title: 'OT (Hours)',
                        field: 'OtHours',
                        render: rowData => {
                          return rowData?.OtHours ? (
                            <div className="round_attendance">
                              {rowData.OtHours}
                            </div>
                          ) : <div className="round_attendance_zero">0</div>;

                        }
                      },

                      // { title: 'OT Hours', field: 'OtHours' },
                      {
                        title: 'Location',
                        field: 'location',
                        render: rowData => {
                          try {
                            const location = JSON.parse(rowData.location);
                            if (location.latitude && location.longitude) {
                              return `Latitude: ${location.latitude}, Longitude: ${location.longitude}`;
                            }
                          } catch {
                            return rowData.location;
                          }
                        },
                        cellStyle: { width: '250px', minWidth: '250px', textAlign: 'center' },
                        headerStyle: { width: '250px', minWidth: '250px', textAlign: 'center' },
                      },
                      {
                        title: 'Action',
                        render: rowData => (
                          hasPermission('M11B7') && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id={`tooltip-edit-${rowData.id}`}>Update Attendance</Tooltip>}
                            >
                              <Button
                                size="sm"
                                variant="outline-info"
                                onClick={() => this.updateAttendance(rowData)}
                              >
                                <i className="fas fa-edit"></i>
                              </Button>
                            </OverlayTrigger>
                          )
                        )
                      }
                    ]}
                    data={this.state.attendanceList.map(({ tableData, ...rest }) => rest)}
                    options={{
                      rowStyle: (_, index) => ({
                        backgroundColor: index % 2 === 0 ? '#fff' : '#f2f2f2'
                      }),
                      pageSize: 10,
                      pageSizeOptions: [10, 20, 30, 50, 75, 100]
                    }}
                    title=""
                  />
                </ThemeProvider>
              </Card.Body>
            </Card>
          </div>


          <Modal
            title="Update Attendance"
            open={this.state.showModal}
            onCancel={() => this.setState({ showModal: false, showPasswordField: false })}
            onOk={this.handleUpdateAttendance}
            okText={this.state.showPasswordField ? "Save" : "Confirm Update"}
            cancelText="Cancel"
          >
            {this.state.selectedAttendance && (
              <Form>
                {this.state.showPasswordField && (
                  <Form.Group>
                    <Form.Label className='required'>Enter Password</Form.Label>
                    <div style={{ position: "relative" }}>
                      <Form.Control
                        type={this.state.showPassword ? "text" : "password"}
                        onChange={this.handleInputChange}
                        value={this.state.password}
                        name="password"
                        placeholder="Enter Your Login Password"
                        required
                      />
                      <span
                        onClick={this.togglePasswordVisibility}
                        style={{
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6c757d"
                        }}
                      >
                        {this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    {/* <Form.Control
                                type="password"
                                onChange={this.handleInputChange}
                                value={this.state.password || ""}
                                name="password"
                                placeholder='Enter Your Login Password'
                                required
                              /> */}
                  </Form.Group>

                )}
                {
                  !this.state.showPasswordField && (
                    <>
                      <Form.Group>
                        <Form.Label>Employee ID</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.empid} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Employee Name</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.employeeName} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Start Time</Form.Label>
                        <Form.Control
                          step="1"
                          type="time"
                          name="startTime"
                          value={this.state.selectedAttendance.startTime}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>End Time</Form.Label>
                        <Form.Control
                          type="time"
                          step="1"
                          name="endTime"
                          value={this.state.selectedAttendance.endTime}
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Number of Hours</Form.Label>
                        <Form.Control type="text" value={this.state.selectedAttendance.numberOfHours} readOnly />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Location</Form.Label>
                        <Form.Control as="textarea"
                          rows={3} value={this.state.selectedAttendance.location} readOnly />
                      </Form.Group>
                    </>)}
              </Form>
            )}
          </Modal>
        </CommonLoader>
      </>
    );
  }
}
export default AttendanceByEmp;